const WHITE = '#FFFFFF';

const BLACK = '#000000';

const ROYAL_BLUE: Record<string, string> = Object.freeze({
  50: '#F5F4FE',
  100: '#DDD7FD',
  200: '#BBB0FB',
  300: '#9988F8',
  400: '#7761F6',
  500: '#5539F4',
  600: '#3C20DA',
  700: '#2206C1',
});

const GRAY = Object.freeze({
  50: WHITE,
  100: '#FAFAFC',
  200: '#EEEEF2',
  300: '#CACAD0',
  400: '#9C9CA1',
  500: '#6D6D71',
  600: '#3D3D42',
  700: '#0D0D13',
});

const BLUE = Object.freeze({
  50: '#E5EFFF',
  100: '#CCE0FF',
  200: '#99C0FF',
  300: '#66A1FF',
  400: '#4D91FF',
  500: '#3382FF',
  600: '#004ECC',
  700: '#003B99',
});

const GREEN = Object.freeze({
  50: '#EAFAF1',
  100: '#D5F6E3',
  200: '#ABEDC7',
  300: '#81E4AA',
  400: '#57DB8E',
  500: '#25AA5C',
  600: '#209E54',
  700: '#1B7E44',
});

const YELLOW = Object.freeze({
  50: '#FEF5E7',
  100: '#FDEBCE',
  200: '#FAD79E',
  300: '#F8C36D',
  400: '#F5AF3D',
  500: '#F39D12',
  600: '#C27C0A',
  700: '#925D07',
});

const RED = Object.freeze({
  50: '#FCEAE8',
  100: '#F9D6D2',
  200: '#F4ACA4',
  300: '#EE8377',
  400: '#E95949',
  500: '#E74D3C',
  600: '#B62616',
  700: '#881D11',
});

const ORANGE = Object.freeze({
  400: '#FFC3A7',
  500: '#FF7D3E',
  600: '#E95D19',
});

const PURPLE = Object.freeze({
  400: '#DFB6F8',
  500: '#BA6CEA',
  600: '#A637EB',
});

const TURQUOISE = Object.freeze({
  400: '#CEE8F3',
  500: '#58C0EB',
  600: '#2BA2D2',
});

export const Colors = Object.freeze({
  white: WHITE,

  black: BLACK,

  primary: GRAY[500],
  primary50: GRAY[50],
  primary100: GRAY[100],
  primary200: GRAY[200],
  primary300: GRAY[300],
  primary400: GRAY[400],
  primary600: GRAY[600],
  primary700: GRAY[700],

  secondary: ROYAL_BLUE[500],
  secondary50: ROYAL_BLUE[50],
  secondary100: ROYAL_BLUE[100],
  secondary200: ROYAL_BLUE[200],
  secondary300: ROYAL_BLUE[300],
  secondary400: ROYAL_BLUE[400],
  secondary600: ROYAL_BLUE[600],
  secondary700: ROYAL_BLUE[700],

  gray: GRAY[500],
  gray50: GRAY[50],
  gray100: GRAY[100],
  gray200: GRAY[200],
  gray300: GRAY[300],
  gray400: GRAY[400],
  gray600: GRAY[600],
  gray700: GRAY[700],

  info: BLUE[500],
  info50: BLUE[50],
  info100: BLUE[100],
  info200: BLUE[200],
  info300: BLUE[300],
  info400: BLUE[400],
  info600: BLUE[600],
  info700: BLUE[700],

  success: GREEN[500],
  success50: GREEN[50],
  success100: GREEN[100],
  success200: GREEN[200],
  success300: GREEN[300],
  success400: GREEN[400],
  success600: GREEN[600],
  success700: GREEN[700],

  warning: YELLOW[500],
  warning50: YELLOW[50],
  warning100: YELLOW[100],
  warning200: YELLOW[200],
  warning300: YELLOW[300],
  warning400: YELLOW[400],
  warning600: YELLOW[600],
  warning700: YELLOW[700],

  error: RED[500],
  error50: RED[50],
  error100: RED[100],
  error200: RED[200],
  error300: RED[300],
  error400: RED[400],
  error600: RED[600],
  error700: RED[700],

  orange: ORANGE[500],
  orange400: ORANGE[400],
  orange600: ORANGE[600],

  purple: PURPLE[500],
  purple400: PURPLE[400],
  purple600: PURPLE[600],

  turquoise: TURQUOISE[500],
  turquoise400: TURQUOISE[400],
  turquoise600: TURQUOISE[600],
});

export const addOpacityToHex = (hex: string, opacity: number) =>
  hex + (opacity * 255).toString(16).split('.')[0];
